export default "__VITE_ASSET__gfx0gUhh__"